import useSWR from "swr";
import axios from "../../config/axiosv2";

const useRoles = (isOpen = true) => {
    const { data: response, error, mutate } = useSWR(isOpen ? '/roles' : null, axios.get, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: true
    })
    const data = response ? response.data : null;

    return {
        data,
        isLoading: !response,
        isError: error,
        mutate
    }
}

export default useRoles;